import React, { Component } from "react";
import { Link } from "react-router-dom";
import ImgLogo from "../../images/logohb.png";

export class Header extends Component {
  render = () => {
    return (
      <header className="main-header header-style-three">
        <div className="header-upper">
          <div className="auto-container clearfix">
            <div className="pull-left logo-outer">
              <div className="logo">
                <Link to="/">
                  <img src={ImgLogo} alt="logo" width="250" />
                </Link>
              </div>
            </div>
            <div className="pull-right upper-right">
              <div className="row clearfix">
                <div className="col-lg-4 col-sm-4 col-xs-4 info-box">
                  <div className="icon-box">
                    <span className="fa fa-clock"></span>
                  </div>
                  <ul>
                    <li>
                      <strong>9:00 a 19:00 hrs</strong>De lunes a viernes
                    </li>
                  </ul>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-4 info-box">
                  <div className="icon-box">
                    <span className="fab fa-whatsapp"></span>
                  </div>
                  <ul>
                    <li>
                      <strong>
                        <a
                          href="tel:+56961922323"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          +56 9 6192 2323
                        </a>
                      </strong>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-4 col-sm-3 col-xs-3 info-box">
                  <div className="icon-box">
                    <span className="fa fa-envelope"></span>
                  </div>
                  <ul>
                    <li>
                      <strong>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="mailto:contacto@contasi.cl"
                        >
                          contacto@contasi.cl
                        </a>
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-lower clearfix">
          <div className="auto-container">
            <div className="nav-outer clearfix">
              <nav className="main-menu navbar-expand-md">
                <div className="navbar-header">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>
                <div
                  className="navbar-collapse collapse clearfix"
                  id="navbarSupportedContent"
                >
                  <ul className="navigation clearfix">
                    <li>
                      <Link to="/">Inicio</Link>
                    </li>
                    <li>
                      <Link to="/empresa">Empresa</Link>
                    </li>
                    <li>
                      <Link to="/contacto">Contacto</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    );
  };
}
export default Header;
